import * as React from 'react'

import MenuItem from './menuItem/menuItem'

import * as styles from './horizontalMenu.module.css'

interface IProps {
  children?: React.ReactNode
}

interface IHorizontalMenu extends React.SFC<IProps> {
  MenuItem: typeof MenuItem
}

const HorizontalMenu: IHorizontalMenu = ({ children }) => {
  return (
    <nav>
      <ul className={styles.list}>{children}</ul>
    </nav>
  )
}

HorizontalMenu.MenuItem = MenuItem
HorizontalMenu.MenuItem.displayName = 'HorizontalMenu.MenuItem'

export default HorizontalMenu
